import { createActionGroup, props } from '@ngrx/store';

import { Label } from './labels.state';

export const labelActions = createActionGroup({
  source: 'Label',
  events: {
    'Fetch Labels By UUID': props<{ uuids: string[] }>(),
    'Fetch Labels By UUID Success': props<{ labels: Label[] }>(),
    'Fetch Labels By UUID Failure': props<{ error: string }>(),
  },
});
